import { ExtranetUserDto } from '@pharmac-extranet/extranet-api'
import Keycloak from 'keycloak-js'
import { AuthenticatedUserDto, KeycloakParsedToken } from './dto'

export const createUserData = (
  keycloakData: KeycloakParsedToken,
  extranetData: ExtranetUserDto
): AuthenticatedUserDto => {
  return {
    ...extranetData,
    tokenExp: keycloakData.exp,
    tokenIat: keycloakData.iat,
    authenticationTime: keycloakData.auth_time,
    username: keycloakData.preferred_username,
    realmAccess: {
      roles: keycloakData.realm_access.roles,
    },
    resourceAccess: keycloakData.resource_access,
    keycloakId: keycloakData.sub,
  }
}

const { VITE_KEYCLOAK_REALM, VITE_KEYCLOAK_CLIENT_ID, VITE_KEYCLOAK_URL } = import.meta.env

export const initializeKeycloak = async () => {
  const keycloak = new Keycloak({
    realm: VITE_KEYCLOAK_REALM,
    clientId: VITE_KEYCLOAK_CLIENT_ID,
    url: VITE_KEYCLOAK_URL,
  })

  const isAuthenticated = await keycloak.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  })

  if (!isAuthenticated) console.error('User is not authenticated')

  return keycloak
}
